<template>
  <div class="pe-box">
    <div class="top-area">
      <div class="top-area-text">
        <div class="about-us-title">中国生活を全面支援する総合アプリ</div>
        <div class="about-us-demo">
          操作画面は完全・日本語環境。ネットショッピング、携帯電話料金のチャージ、音声・文字翻訳、為替計算、イエローページ等、あらゆる生活＆ビジネスシーンで役立つ機能を盛りだくさん搭載しています。
        </div>
      </div>

      <div class="top-image-area">
        <img :src="aboutImg" />
      </div>
    </div>

    <div class="bottom-area">
      <div class="contact-us-box">
        <div class="contact-us-text1">
          <div class="contact-us-title">Message</div>
          <div class="contact-us-list">
            <span class="contact-us-msg">
              <img :src="aboutmsg" alt="" />
            </span>
            <span class="contact-us-text">info@nanaco.com.cn</span>
          </div>
        </div>
        <div class="contact-us-icon">
          <div class="contact-us-imgB"><img :src="aboutbird" alt="" /></div>
          <div class="contact-us-imgF"><img :src="aboutf" alt="" /></div>
        </div>
      </div>

      <div class="app-download">
        <div class="app-download-top-img">
          <img
            v-for="(item, index) in peAppDownload"
            :src="item"
            :key="index"
          />
        </div>
        <div class="app-download-bottom-img">
          <img
            v-for="(item, index) in peAppDownloadQrcode"
            :src="item"
            :key="index"
          />
        </div>
      </div>
      <!-- <div class="link-us-box">
        <div class="link-us-fun">
          <div class="link-us-msg" @click="phoneTo()">
            <Icon type="ios-call" class="icon" />talk to us
          </div>
          <div class="link-us-msg" @click="mailTo()">
            <Icon type="md-mail" class="icon" />mail to us
          </div>
        </div>
        <div class="link-us-fun">
          <div
            class="link-us-msg"
            style="background: #273978"
            @click="toFaceBook()"
          >
            <Icon type="logo-facebook" class="icon" />Facebook
          </div>
          <div
            class="link-us-msg"
            style="background: #2698d1"
            @click="toTwitter()"
          >
            <Icon type="logo-twitter" class="icon" />Twitter
          </div>
        </div>
      </div> -->
      <!-- <div class="link-us-qrcode">
        <div>
          <img :src="downloadImage.heyNanaco" />
          <img />
        </div>
        <div>
          <img :src="downloadImage.ios" />
          <img />
        </div>
        <div>
          <img :src="downloadImage.android" />
          <img />
        </div>
      </div> -->
    </div>
    <div class="whitesolid"></div>
    <div class="record-no" @click="linkTo()">辽ICP备17016868号-3</div>
  </div>
</template>
<script>
import {
  downloadImage,
  aboutUs,
  aboutImg,
  aboutbird,
  aboutf,
  aboutmsg,
  peAppDownload,
  peAppDownloadQrcode,
} from "../../images/home/index";
export default {
  data() {
    return {
      boxPosition: "100",
      downloadImage,
      aboutUs,
      aboutImg,
      aboutbird,
      aboutf,
      aboutmsg,
      peAppDownloadQrcode,
      peAppDownload,
    };
  },
  methods: {
    init() {
      // this.isCanvasShow = true
      // this.$nextTick(() => {
      //   RENDERER.init(document.getElementsByClassName('canvas-area')[0])
      // })
    },
    up() {
      this.boxPosition = "-100";
      // RENDERER.stop()
      // this.isCanvasShow = false
    },
    nomal() {
      this.boxPosition = "0";
      // this.init()
    },
    down() {
      this.boxPosition = "100";
      // RENDERER.stop()
      // this.isCanvasShow = false
    },
    linkTo() {
      window.open("http://beian.miit.gov.cn/");
    },
    toFaceBook() {
      window.open("https://www.facebook.com/nanacokume");
    },
    toTwitter() {
      window.open("https://twitter.com/nanacokume");
    },
    mailTo() {
      location.href = "mailto:info@nanaco.com.cn";
    },
    phoneTo() {
      location.href = "tel:4001752874";
    },
  },
};
</script>
<style scoped>
@media only screen and (min-height: 500px) {
  .pe-box {
    font-size: 21px;
  }
}
@media only screen and (min-height: 623px) {
  .pe-box {
    font-size: 22.5px;
  }
}
.pe-box {
  background: #252d52;
  width: 100%;
  /* height: 100%; */
}
.top-area {
  width: 100%;
  height: 55%;
  margin-top: 2rem;
  background-color: #e4ebff;
  color: #050b1a;
  position: absolute;
  top: 0;
  left: 0;
}
.top-area-text {
  width: 100%;
  position: absolute;
  bottom: 0.5em;
  z-index: 6;
  color: #000;
}
.top-image-area {
  width: 13em;
  height: 10em;
  position: absolute;
  top: 2em;
  left: 50%;
  margin-left: -6.5em;

  overflow: hidden;
}
.top-image-area img {
  width: 100%;
}
.about-us-title {
  font-weight: bold;
  text-align: center;
  font-size: 1rem;
  margin: 0.5rem 0;
}
.about-us-demo {
  width: 100%;
  font-size: 0.4em;
  box-sizing: border-box;
  padding: 0 0.4rem;
  line-height: 0.8rem;
  margin-top: 0.1rem;

  font-weight: normal;
}
.bottom-area {
  width: 100%;
  height: 40%;
  box-sizing: border-box;
  position: absolute;
  bottom: 1em;

  display: flex;
  z-index: 0;
}
.contact-us-box {
  display: flex;
  position: absolute;
  bottom: 7em;
  width: 100%;
  /* justify-content: space-around; */
}
.contact-us-icon {
  position: absolute;
  display: flex;
  width: 4rem;
  justify-content: space-around;
  right: 0.5em;
  bottom: 0.5rem;
}
.contact-us-text1 {
  position: absolute;
  bottom: 0.5rem;
  left: 0em;
}
.contact-us-title {
  position: absolute;
  bottom: 1em;
  margin-left: 1rem;
  font-size: 0.8em;
  font-weight: bold;
  color: #707691;
}
.contact-us-list {
  margin-top: 1em;
}
.contact-us-msg img {
  width: 0.4em;
  height: auto;
  margin-left: 1rem;
  margin-top: 1rem;
}
.contact-us-text {
  font-size: 0.5em;
  color: white;
}
.contact-us-imgB img {
  width: 1em;
}
.contact-us-imgF img {
  width: 1em;
}
.app-download-top-img {
  position: absolute;
  bottom: 5.2rem;
  left: 0;
  width: 100%;
  display: flex;
  justify-content: space-around;
}
.app-download-top-img img {
  width: 20%;
  height: 20%;
}
.app-download-bottom-img {
  position: absolute;
  bottom: 1rem;
  left: 0;
  width: 100%;
  display: flex;
  justify-content: space-around;
}
.app-download-bottom-img img {
  width: 20%;
  height: 20%;
}
.whitesolid {
  width: 90%;
  height: 0.02em;
  background-color: #ffffff;
  position: absolute;
  bottom: 8em;
  left: 50%;
  margin-left: -45%;
}
/* .ss{
  font-size: 0.25rem;
  font-weight: bold;
  color: #707691;
}
.link-us-box {
  width: 100%;
  box-sizing: border-box;
  padding: 0 2rem;
  height: 100%;
  display: flex;
}
.link-us-fun {
  flex: 1;
  box-sizing: border-box;
  vertical-align: top;
}
.link-us-title {
  font-size: 15px;
  font-weight: bold;
  color: #707691;
}
.link-us-msg {
  background: #fff;
  border-radius: 5px;
  width: 90%;
  padding: 5px;
  margin: 0 0.5rem;
  margin-top: 0.5rem;
  vertical-align: top;
  cursor: pointer;
  line-height: 1rem;
  font-size: 0.6rem;
}
.link-us-msg .icon {
  font-size: 20px;
  margin-right: 5px;
  vertical-align: top;
}
.link-us-qrcode {
  width: 500px;
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  padding-left: 50px;
}
.link-us-qrcode div {
  width: 150px;
  margin: 0 10px;
}
.link-us-qrcode div img:nth-child(1) {
  display: block;
  width: 100%;
}
.link-us-qrcode div img:nth-child(2) {
  width: 140px;
  height: 140px;
  border: solid 5px #222;
  margin-top: 20px;
} */
.record-no {
  width: 18em;
  text-align: center;
  position: absolute;
  bottom: 0.5em;
  height: 1.5em;
  left: 50%;
  margin-left: -9em;
  color: white;
  font-size: 0.6em;
  line-height: 1.5em;
  z-index: 9;
}
/* .link-us-box .link-us-fun:nth-child(2) .link-us-msg {
  color: #fff;
} */
</style>


// WEBPACK FOOTER //
// src/components/pe-home/modules/about-us.vue